"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _useVideoModal = require("b2b-components/hooks/useVideoModal");
var _useVideoThumbnail = require("b2b-components/hooks/useVideoThumbnail");
var _Card = require("./Card");
const CardContainer = _ref => {
  let {
    imageUrl,
    videoUrl,
    cta,
    title,
    bottomHtmlText,
    topHtmlText,
    size,
    onCtaClick,
    dataAttributes,
    className
  } = _ref;
  const videoThumbnailUrl = (0, _useVideoThumbnail.useVideoThumbnail)(videoUrl);
  const {
    isVideoModalOpened,
    onVideoModalClose,
    onVideoPlayClick
  } = (0, _useVideoModal.useVideoModal)();
  const handleCtaClick = () => {
    cta?.url && onCtaClick?.(cta.url);
  };
  return /*#__PURE__*/_react.default.createElement(_Card.Card, {
    imageUrl: imageUrl,
    videoUrl: videoUrl,
    videoThumbnailUrl: videoThumbnailUrl,
    cta: cta,
    title: title,
    bottomHtmlText: bottomHtmlText,
    topHtmlText: topHtmlText,
    size: size,
    isVideoModalOpened: isVideoModalOpened,
    onCtaClick: handleCtaClick,
    onVideoModalClose: onVideoModalClose,
    onVideoPlayClick: onVideoPlayClick,
    dataAttributes: dataAttributes,
    className: className
  });
};
exports.Card = CardContainer;
//# sourceMappingURL=CardContainer.js.map